import { motion } from 'framer-motion'
import './ProtocolDocs.css'

export default function ProtocolDocs() {
    const specs = [
        {
            title: 'Batching Logic',
            value: 'Atomic',
            description: 'Multi-transaction settlement in single block'
        },
        {
            title: 'API Latency',
            value: '<100ms',
            description: 'Global node distribution for propagation delay reduction'
        },
        {
            title: 'Network Support',
            value: 'TRC20, ERC20, TON',
            description: 'Cross-chain atomic settlement rails'
        },
        {
            title: 'Throughput Efficiency',
            value: '99.9%',
            description: 'Slippage mitigation on high-volume operations'
        },
        {
            title: 'Encryption Standard',
            value: 'TLS 1.3 / AES-256',
            description: 'Cryptographic verification at every stage'
        },
        {
            title: 'Settlement Velocity',
            value: 'Sub-second',
            description: 'Liquidity velocity optimization for institutional rails'
        }
    ]

    const protocolRails = [
        {
            title: 'Propagation Delay Reduction',
            description: 'Sub-200ms global node latency'
        },
        {
            title: 'Synthetic Liquidity Depth',
            description: 'Aggregated institutional pool access'
        },
        {
            title: 'Slippage Mitigation',
            description: 'Algorithmic routing for zero-slippage execution'
        },
        {
            title: 'Atomic Settlement',
            description: 'All-or-nothing transaction finality'
        }
    ]

    return (
        <section className="protocol-docs-section" id="protocol">
            <div className="container">
                <motion.div
                    className="section-header"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="section-title">
                        Protocol <span className="text-neon">Infrastructure</span>
                    </h2>
                    <p className="section-subtitle">
                        Technical specifications for institutional-grade USDT settlement
                    </p>
                </motion.div>

                <div className="specs-grid">
                    {specs.map((spec, index) => (
                        <motion.div
                            key={index}
                            className="spec-card glass"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.1 }}
                            whileHover={{ scale: 1.05 }}
                        >
                            <h3 className="spec-title">{spec.title}</h3>
                            <p className="spec-value">{spec.value}</p>
                            <p className="spec-description">{spec.description}</p>
                        </motion.div>
                    ))}
                </div>

                <motion.div
                    className="protocol-rails glass"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.6 }}
                >
                    <h3 className="rails-title">Protocol Rails Architecture</h3>
                    <ul className="rails-list">
                        {protocolRails.map((rail, index) => (
                            <li key={index} className="rail-item">
                                <strong>{rail.title}:</strong> {rail.description}
                            </li>
                        ))}
                    </ul>
                </motion.div>
            </div>
        </section>
    )
}
